/**
 * Znak Pinveo — rzut obiektu: trzy pomieszczenia o różnych proporcjach, jedno
 * oznaczone w hi-vis. Zbieżny z ikoną aplikacji mobilnej i `favicon.svg`.
 * Źródła i zasady: `inspector_mobile/docs/brand/` (README.md + pinveo-*.svg).
 *
 * Ściany rysowane `currentColor` (paper na ink-tile w sidebarze/shellu, ink w
 * jasnym headerze), oznaczone pole zawsze hi-vis (#ff5a1f) — akcent brandu i
 * sygnał „to jest ten punkt".
 *
 * Geometria to przeskalowany master (układ 512 → 24): ściana pionowa na 42,3%
 * szerokości, pozioma na 53,8% wysokości. Nieregularny podział jest sygnaturą
 * znaku — nie wyrównywać do równej kratki.
 */
export function AppLogo({ className = 'h-5 w-5' }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="miter"
      aria-hidden="true"
    >
      {/* Oznaczone pole — hi-vis, wcięte do wewnętrznych krawędzi ścian */}
      <rect x="11.5" y="4.4" width="8.1" height="7.4" fill="#ff5a1f" stroke="none" />
      {/* Ściany: obrys + podział pionowy i poziomy */}
      <rect x="3.6" y="3.6" width="16.8" height="16.8" />
      <path d="M10.7 3.6 V20.4 M10.7 12.6 H20.4" />
    </svg>
  );
}
